<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.375 18.125H15.625V11.25H4.375V18.125ZM5.9375 12.8125H14.0625V16.5625H5.9375V12.8125ZM17.6562 5.625H15.625V0.9375H4.375V5.625H2.34375C1.80523 5.62566 1.28896 5.83988 0.90817 6.22067C0.52738 6.60146 0.313162 7.11773 0.3125 7.65625V13.9062C0.3125 15.0262 1.22375 15.9375 2.34375 15.9375H3.125V14.375H2.34375C2.21993 14.3734 2.10164 14.3235 2.01408 14.2359C1.92652 14.1484 1.87662 14.0301 1.875 13.9062V7.65625C1.875 7.40188 2.09 7.1875 2.34375 7.1875H17.6562C17.9103 7.1875 18.125 7.40188 18.125 7.65625V13.9062C18.125 14.1606 17.91 14.375 17.6562 14.375H16.875V15.9375H17.6562C18.7763 15.9375 19.6875 15.0262 19.6875 13.9062V7.65625C19.6875 6.53625 18.7763 5.625 17.6562 5.625ZM14.0625 5.625H5.9375V2.5H14.0625V5.625ZM16.875 8.4375H15.3125V10H16.875V8.4375Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Printer',
} as DefineComponent
</script>
